// components/OnlineStatus.jsx
import React from 'react';
import { useOnlineStatus } from '../helpers/ablyPresence';

const OnlineStatus = ({ userId, size = 10 }) => {
  const isOnline = useOnlineStatus(userId);
  return (
    <span
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: isOnline ? '#4caf50' : '#9e9e9e',
        marginRight: 4,
      }}
    />
  );
};

export default OnlineStatus;